(ns metabase.util.match
  (:require
   [metabase.util.match.impl])
  (:require-macros [metabase.util.match]))

(comment metabase.util.match/keep-me
         metabase.util.match.impl/keep-me)
